var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 21.75,
    rx: 2.5,
    stroke: "#05CD99",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6485 5.82975C13.5529 5.79144 13.4462 5.79144 13.3506 5.82975L8.57188 7.74107L13.4995 9.71165L18.4272 7.74107L13.6485 5.82975ZM19.1046 8.3328L13.8999 10.4147V16.758L19.1046 14.6761V8.3328ZM13.0992 16.7588V10.4139L7.89447 8.3328V14.6769L13.0992 16.7588ZM13.0535 5.08588C13.3398 4.97137 13.6592 4.97137 13.9455 5.08588L19.6539 7.36954C19.7281 7.39928 19.7917 7.45056 19.8365 7.51678C19.8813 7.583 19.9053 7.66112 19.9053 7.74107V14.6769C19.9052 14.8369 19.8572 14.9932 19.7674 15.1257C19.6776 15.2581 19.5502 15.3606 19.4016 15.42L13.6485 17.7213C13.5529 17.7596 13.4462 17.7596 13.3506 17.7213L7.5982 15.42C7.44947 15.3608 7.32191 15.2583 7.23199 15.1258C7.14207 14.9934 7.09392 14.837 7.09375 14.6769V7.74107C7.09377 7.66112 7.11773 7.583 7.16254 7.51678C7.20735 7.45056 7.27096 7.39928 7.34518 7.36954L13.0535 5.08588Z",
    fill: "#00AD7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcel);
export default __webpack_public_path__ + "static/media/parcel.32031c5a990c3f6c5e0e09737ff39d90.svg";
export { ForwardRef as ReactComponent };